module.exports = "<p>registro works!</p>\n"